import { saveAs } from "file-saver";
import contentDisposition from "content-disposition";

function saveFile(response, fileName?, applicationType?) {
  applicationType = applicationType || response.type || response.contentType;
  fileName = fileName || response.name;
  const blob = response.blob || response;

  const data = new Blob([blob], {
    type: applicationType,
  });

  if (navigator.userAgent.match("CriOS")) {
    const fileUrl = URL.createObjectURL(data);
    window.open(fileUrl);
  } else {
    saveAs(data, fileName);
  }
}

export function b64toBlob(b64Data, contentType = "", sliceSize = 512) {
  const byteCharacters = atob(b64Data);
  const byteArrays = [] as any;

  for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    const slice = byteCharacters.slice(offset, offset + sliceSize);

    const byteNumbers = new Array(slice.length);
    for (let i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);
    byteArrays.push(byteArray);
  }

  const blob = new Blob(byteArrays, { type: contentType });
  return blob;
}

export function saveBlob(blob, fileName) {
  if (navigator.userAgent.match("CriOS")) {
    const fileUrl = URL.createObjectURL(blob);
    window.open(fileUrl);
  } else {
    saveAs(blob, fileName);
  }

  // saveAs(blob, fileName);
}

export function transformDownload(data, headers) {
  let fileName;
  const contentType = headers["content-type"];
  const contentLength = headers["content-length"];

  const cd = headers["content-disposition"];
  if (cd) {
    const disposition = contentDisposition.parse(cd);
    fileName = disposition.parameters.filename;
  }

  if (!fileName) {
    fileName = "filnavn.mangler";
  }

  const newData = {} as any;
  newData.blob = data;
  newData.name = fileName;
  newData.contentType = contentType;
  newData.fileSize = contentLength;
  return newData;
}

export function getFileNameFromHeader(header) {
  let fileName;
  const cd = header["content-disposition"];
  if (cd) {
    const disposition = contentDisposition.parse(cd);
    fileName = disposition.parameters.filename;
  }
  return fileName;
}

export default saveFile;
